import React from 'react';

export function EmailHeaderLogoWithCoverImage(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.9761 1.4502H9.02381C9.70365 1.4502 10.2473 1.45019 10.6867 1.48609C11.1376 1.52293 11.5267 1.6003 11.8846 1.78263C12.4585 2.07504 12.9251 2.54164 13.2175 3.11553C13.3998 3.47338 13.4772 3.86253 13.514 4.31342C13.5499 4.75277 13.5499 5.29652 13.5499 5.97637V8.02403C13.5499 8.70388 13.5499 9.24763 13.514 9.68698C13.4772 10.1379 13.3998 10.527 13.2175 10.8849C12.9251 11.4588 12.4585 11.9254 11.8846 12.2178C11.5267 12.4001 11.1376 12.4775 10.6867 12.5143C10.2473 12.5502 9.70363 12.5502 9.02378 12.5502H4.97612C4.29627 12.5502 3.75252 12.5502 3.31317 12.5143C2.86228 12.4775 2.47313 12.4001 2.11528 12.2178C1.54139 11.9254 1.0748 11.4588 0.782382 10.8849C0.600049 10.527 0.522678 10.1379 0.485839 9.68698C0.449943 9.24764 0.449946 8.70389 0.449951 8.02405V5.97635C0.449946 5.29651 0.449943 4.75276 0.485839 4.31342C0.522678 3.86253 0.600049 3.47338 0.782382 3.11553C1.0748 2.54164 1.54139 2.07504 2.11528 1.78263C2.47313 1.6003 2.86228 1.52293 3.31317 1.48609C3.75252 1.45019 4.29626 1.4502 4.9761 1.4502ZM3.40274 2.58243C3.01988 2.61372 2.7916 2.67259 2.61467 2.76274C2.24776 2.94969 1.94944 3.248 1.76249 3.61492C1.67234 3.79185 1.61347 4.02013 1.58219 4.40299C1.55038 4.79228 1.54995 5.29106 1.54995 6.0002V8.0002C1.54995 8.70934 1.55038 9.20812 1.58219 9.59741C1.61347 9.98028 1.67234 10.2086 1.76249 10.3855C1.94944 10.7524 2.24776 11.0507 2.61467 11.2377C2.7916 11.3278 3.01988 11.3867 3.40274 11.418C3.79203 11.4498 4.29081 11.4502 4.99995 11.4502H8.99995C9.70909 11.4502 10.2078 11.4498 10.5971 11.418C10.98 11.3867 11.2083 11.3278 11.3852 11.2377C11.7521 11.0507 12.0504 10.7524 12.2374 10.3855C12.3275 10.2086 12.3864 9.98028 12.4177 9.59741C12.4495 9.20812 12.4499 8.70934 12.4499 8.0002V6.0002C12.4499 5.29106 12.4495 4.79228 12.4177 4.40299C12.3864 4.02013 12.3275 3.79185 12.2374 3.61492C12.0504 3.248 11.7521 2.94969 11.3852 2.76274C11.2083 2.67259 10.98 2.61372 10.5971 2.58243C10.2078 2.55063 9.70909 2.5502 8.99995 2.5502H4.99995C4.29081 2.5502 3.79203 2.55063 3.40274 2.58243Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.1999 0.450195C4.50366 0.450195 4.7499 0.696438 4.7499 1.00019V2.75019C4.7499 3.05395 4.50366 3.30019 4.1999 3.30019C3.89614 3.30019 3.6499 3.05395 3.6499 2.75019V1.00019C3.6499 0.696438 3.89614 0.450195 4.1999 0.450195Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.80024 0.450195C10.104 0.450195 10.3503 0.696438 10.3503 1.00019V2.75019C10.3503 3.05395 10.104 3.30019 9.80024 3.30019C9.49649 3.30019 9.25024 3.05395 9.25024 2.75019V1.00019C9.25024 0.696438 9.49649 0.450195 9.80024 0.450195Z"
        fill="currentColor"
      />
      <mask id="path-4-inside-1_1046_22311" fill="white">
        <rect x="3" y="4" width="8" height="3" rx="0.5" />
      </mask>
      <rect
        x="3"
        y="4"
        width="8"
        height="3"
        rx="0.5"
        stroke="currentColor"
        stroke-width="2"
        mask="url(#path-4-inside-1_1046_22311)"
      />
      <mask id="path-5-inside-2_1046_22311" fill="white">
        <rect x="6" y="8" width="5" height="2" rx="0.5" />
      </mask>
      <rect
        x="6"
        y="8"
        width="5"
        height="2"
        rx="0.5"
        stroke="currentColor"
        stroke-width="2"
        mask="url(#path-5-inside-2_1046_22311)"
      />
      <mask id="path-6-inside-3_1046_22311" fill="white">
        <rect x="3" y="8" width="2" height="2" rx="0.5" />
      </mask>
      <rect
        x="3"
        y="8"
        width="2"
        height="2"
        rx="0.5"
        stroke="currentColor"
        stroke-width="2"
        mask="url(#path-6-inside-3_1046_22311)"
      />
    </svg>
  );
}
